import Anchors from '../modules/components/anchors';
import Header from '../modules/components/header';
import Menu from '../modules/components/menu';

function entry() {
  new Menu();
  new Header('.site-header', 0, 'sticky');

  new Anchors();

}

window.addEventListener('DOMContentLoaded', entry);
